import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextSelect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextSelect"><Path d="M4 2C2.34315 2 1 3.34315 1 5C1 6.30622 1.83481 7.41746 3 7.82929V20H14V18H5V7.82929C6.16519 7.41746 7 6.30622 7 5C7 3.34315 5.65685 2 4 2Z" fill="currentColor"/><Path d="M10 4V6H19V16.1707C17.8348 16.5825 17 17.6938 17 19C17 20.6569 18.3431 22 20 22C21.6569 22 23 20.6569 23 19C23 17.6938 22.1652 16.5825 21 16.1707V4H10Z" fill="currentColor"/><Path d="M8 9V11H16V9H8Z" fill="currentColor"/><Path d="M8 13V15H14V13H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextSelect;
